import styled from 'styled-components';

import theme from '../constants/theme';

export const ViewContainer = styled.div`
  background: ${theme.backgroundColor};
  overflow: scroll;
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100vh;

  ${Styles.desktop`
    flex-flow: row;
  `}
`;
